import { lumiApi } from "../index";

export const conceptsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getAllConcepts: build.query({
            query: (id) => `/projects/${id}/concepts?type=top&limit=500`,
            providesTags: () => [{ type: "ConceptsAll" }],
        }),
        getConceptsList: build.query({
            query: (id) => `/projects/${id}/concept_lists`,
            providesTags: () => [{ type: "List" }],
        }),
        getConceptMetaData: build.query({
            query: (id) => `/projects/${id}/metadata/?max_values=10000`,
            transformResponse({ result }) {
                const staticElementsDate = ["date"];
                const staticElementsDrivers = ["score", "number"];
                const staticElementsStrings = ["string"];


                const metaDataDrivers = [];
                const metaDataDate = [];
                let metaDataWithStringType = [];
                const names = [];

                const metaData = result.map((el) => {
                    names.push(el.name);
                    if (staticElementsDrivers.includes(el.type)) {
                        metaDataDrivers.push(el);
                    }

                    if (staticElementsDate.includes(el.type)) {
                        metaDataDate.push(el);
                    }

                    if (staticElementsStrings.includes(el.type)) {
                        metaDataWithStringType.push(el);
                    }

                    if (el.type === "number" && Array.isArray(el.values)) {
                        el.values = el.values.map((val) => ({
                            ...val,
                            value:
                                typeof val.value === "number"
                                    ? val.value.toFixed(1)
                                    : val.value,
                        }));
                    }

                    if (el.type === "date") {
                        el.values = [];
                    }

                    return el;
                });
                metaDataWithStringType = metaDataWithStringType.filter(
                    (item) => item.values && item.values.length > 0
                );
                return {
                    metaData,
                    metaDataDrivers,
                    metaDataDate,
                    metaDataWithStringType,
                    names,
                };
            },
        }),
        getConceptsOptions: build.mutation({
            query: ({ id, concept_selector, filter = null }) => {
                const body = filter
                    ? { concept_selector, filter }
                    : { concept_selector };

                return {
                    url: `/projects/${id}/concepts`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
        getConceptsFilters: build.mutation({
            query: ({
                id,
                concept_selector,
                filter = null,
                breakdowns = [],
            }) => {
                const body = { concept_selector, filter, breakdowns };

                return {
                    url: `/projects/${id}/concepts/match_counts`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
        getConcept: build.mutation({
            query: ({ id, filter = [], search = null }) => {
                const body = { filter, search };

                return {
                    url: `/projects/${id}/concepts/search_details`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
    }),
});

export const {
    useGetConceptsListQuery,
    useGetConceptMetaDataQuery,
    useGetConceptsOptionsMutation,
    useGetConceptsFiltersMutation,
} = conceptsApi;
